export const HomePageLang = {
  ABOUT_US: "ABOUT US",
  ABOUT_SECTION_DESC_1: `Luton Ceramic Pvt. Ltd. is a leading manufacturer of Digital Parking tiles in Morbi — India’s ceramic hub. Combining
                state‑of‑the‑art production lines, advanced digital printing and
                strict quality control. The ceramic industry has always been the most tradition-driven units of manufacturing. We at Luton thought something different and made the unit technology-intensive. we deliver a broad portfolio including
                parking tiles, that meet international performance and finish
                standards.`,
  ABOUT_SECTION_DESC_2: `Sustainability and innovation are core to our approach: we
                invest in energy‑efficient kilns, water‑recycling systems and
                continuous R&D to expand design range and improve durability.
                With 1000+ designs, flexible finishing options and end‑to‑end
                technical support, Luton Ceramic Pvt. Ltd. is trusted by architects,
                contractors and distributors across the Domestic market, Middle East, Africa,
                South Asia and Latin America for consistent sizing, long‑lasting
                colour and timely delivery.`,
  EXPLORE_MORE: "EXPLORE MORE",
  OUR_COLLECTIONS: "Our Collections",
  COLLECTIONS_DESC: `Discover our diverse range of Digital Parkingiles,
                crafted to elevate any space with style and durability. From
                contemporary designs to classic aesthetics, our collections
                cater to every taste and requirement.`,
  EXPLORE_OUR_COLLECTION: "Explore Our Collection",
  WHAT_MAKES_US_BEST: "What Makes Luton Ceramic Pvt. Ltd. The Best Tile Supplier?",
  WHY_BEST_MESSAGE:"Below are some reasons that we think make us the best tiles suppliers.",

  DIGITAL_PARKING_TILES: "DIGITAL PARKING TILE EXPERTISE",
  DIGITAL_PARKING_TILES_DESC: "Based in Morbi, Gujarat, Luton Ceramic Pvt. Ltd. specializes in the manufacturing and supply of digital parking tiles, including dimensions like 400x400mm and 500x500mm heavy-duty variants.",

  GLOBAL_EXPORT_NETWORK: "GLOBAL EXPORT NETWORK",
  GLOBAL_EXPORT_NETWORK_DESC: "Luton Ceramic Pvt. Ltd. exports its tiles to several countries, supported by a strong export infrastructure and international presence.",

  ROBUST_INFRASTRUCTURE: "ROBUST INFRASTRUCTURE",
  ROBUST_INFRASTRUCTURE_DESC: "The company maintains extensive logistics capabilities with nationwide warehouses, depots, and reliable transportation facilities.",

  INNOVATION_QUALITY_CONTROL: "INNOVATION & QUALITY CONTROL",
  INNOVATION_QUALITY_CONTROL_DESC: "By focusing on research, advanced technology, and rigorous quality control, Luton produces durable and premium-quality tiles.",

  END_TO_END_SUPPORT: "END-TO-END SUPPORT",
  END_TO_END_SUPPORT_DESC: "Luton Ceramic Pvt. Ltd. offers comprehensive support from product selection to after-sales service, ensuring customer satisfaction throughout the buying process.",

  HAPPY_CLIENTS: "HAPPY CLIENTS",
  HAPPY_CLIENTS_COUNT: "500+",
  PRODUCT_DESIGNS: "PRODUCT DESIGNS",
  PRODUCT_DESIGNS_COUNT: "999+",
  YEARS_OF_EXPERIENCE: "YEARS OF EXPERIENCE",
  YEARS_OF_EXPERIENCE_COUNT: "10+",
  EXPORT_COUNTRIES: "EXPORT COUNTRIES",
  EXPORT_COUNTRIES_COUNT: "15+",

  COME_AND_VISIT: "COME & VISIT US",
  SCHEDULE_YOUR_VISIT: "SCHEDULE YOUR VISIT",

  APPLICATION_AREAS_TITLE: "Application Areas",
  APPLICATION_AREAS_DESC: "Luton Ceramic Pvt. Ltd. tiles are versatile and suitable for a wide range of applications, including residential, commercial, and outdoor spaces. Their durability and aesthetic appeal make them ideal for various settings.",
  HOSPITAL: "Hospital",
  MALL: "Mall",
  OFFICE: "Office",
  SUPERMARKET: "Supermarket",
  AIRPORT: "Airport",
  FACTORY: "Factory",

  INFRASRUCTURE: "Infrastructure",
  INFRASTRUCTURE_DESC: `Innovation <br />Becomes Not Merely An Aim,<br />But a Strategy`,
  INFRASTRUCTURE_LINE_1: "Building smarter facilities that adapt to tomorrow’s challenges, not just today’s needs.",
  INFRASTRUCTURE_LINE_2: "Integrating cutting-edge technologies to optimize efficiency and reduce waste.",
  INFRASTRUCTURE_LINE_3: "Turning innovation into a continuous process, not a one-time achievement.",
  INFRASTRUCTURE_LINE_4: "Aligning infrastructure with global standards for quality, safety, and sustainability.",
  INFRASTRUCTURE_LINE_5: "Positioning infrastructure as a growth engine that drives competitiveness.",
  VIEW_INFRASTRUCTURE: "View Infrastructure",

  EXPORT: "Export",
  GLOBAL_FOOTPRINT: "Global Footprint",
  GLOBAL_FOOTPRINT_DESC: `Our shipments reach many countries worldwide to bring some of the most worthy complexes to life. From the production unit to the packaging unit, we ensure nothing but the best output. We create and deliver the best ceramic products in the country that stand the test of time and quality to match your expectations. We are successfully setting a benchmark and global presence in the past few years to deliver a premium product.`,

  IN_AVIDANCE: "In Evidence",
  COMAPNY: "Company",
  GLOBAL_NETWORK: "Global Network",
  COLLECTION: "Collection",
  CATALOUGE: "Catalogue",

  DOWNLOAD_CATALOGUE: "Download E - Catalogue",
  VISIT_PRODUCT_CATALOGUE: "Visit Product Catalogue",
};
